import { RootState } from '../../../reducers'
import { currentBotConfigurationSelector } from './currentBotConfigurationSelector'

export function isBotArchivedSelector(state: RootState): boolean {
  return !!currentBotConfigurationSelector(state)?.isArchived
}
